<template>
  <div class="typing-indicator">
    <span class="dot" v-for="n in 3" :key="n" :style="{ animationDelay: `${(n - 1) * 0.2}s` }"></span>
  </div>
</template>

<script setup></script>

<style scoped>
.typing-indicator {
  display: flex;
  align-items: center;
  justify-content: start;
  height: 24px;
  gap: 4px;
}

.dot {
  width: 8px;
  height: 8px;
  background-color: #555;
  border-radius: 50%;
  animation: blink 1.2s infinite ease-in-out;
}

@keyframes blink {
  0%, 80%, 100% {
    opacity: 0.2;
    transform: scale(1);
  }
  40% {
    opacity: 1;
    transform: scale(1.3);
  }
}
</style>
